/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
import { PropagationAPI } from './api/propagation';
/**
 * Entrypoint for propagation API
 *
 * @since 1.0.0
 */
export const propagation = PropagationAPI.getInstance();
//# sourceMappingURL=propagation-api.js.map